import { CloudDownloadOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { formatPhoneNumber } from "../../../../utils/appUtils";

const formatAmount = (value) => Number(value || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const rowStyle = { margin: 0, padding: "5px 0" };

export const GST_INVOICE_TABS = [
    { label: "Self Tax Invoices", key: "1", content: "SELF_TAX_INVOICES" },
    { label: "Sales Tax Invoices", key: "2", content: "SALES_TAX_INVOICES" },
    // { label: "Refund Receipts", key: "3", content: "REFUND_RECEIPTS" },
    { label: "TDS Amount", key: "4", content: "TDS_AMOUNT" }
];

export const PAYMENT_CATEGORY_BY_TAB = {
    "1": "SELF_TAX",
    "2": "SALES_TAX",
    "3": "REFUND_TO_CUSTOMER",
    "4": "TDS"
};

export const PAYMENT_DESCRIPTION = {
    SELF_TAX: "Self Tax",
    SALES_TAX: "Sales Tax",
    REFUND_TO_CUSTOMER: "Refund",
    TDS: "TDS Amount",
    LAWYER_ATTORNEY_FEES: "Lawyer Attorney Fees"
};

export const GST_INVOICE_COLUMNS = [
    {
        title: "SNo",
        width: 70,
        align: "center",
        render: (_, detail, index) => <>{index + 1}</>
    },
    {
        title: "Date",
        width: 140,
        dataIndex: "date",
        key: "date",
        render: (date) => <p style={rowStyle}>{date ? dayjs(date).format("DD MMM YYYY") : "Nil"}</p>
    },
    {
        title: "INV No",
        width: 100,
        dataIndex: "invoiceNumber",
        key: "invoiceNumber",
        render: (invoiceNumber) => <p style={rowStyle}>{invoiceNumber || "Nil"}</p>
    },
    {
        title: "Transaction ID",
        width: 170,
        dataIndex: "transactionId",
        key: "transactionId",
        render: (transactionId) => <p style={rowStyle}>{transactionId || "Nil"}</p>
    },
    {
        title: "GST Value",
        width: 140,
        dataIndex: "gstAmount",
        key: "gstAmount",
        render: (gstAmount) => <p style={rowStyle}>{formatAmount(gstAmount)}</p>
    },
    {
        title: "Taxable Value",
        width: 140,
        dataIndex: "taxableValue",
        key: "taxableValue",
        render: (taxableValue) => <p style={rowStyle}>{formatAmount(taxableValue)}</p>
    },
    {
        title: "Total INV Value",
        width: 150,
        dataIndex: "totalInvoiceValue",
        key: "totalInvoiceValue",
        render: (totalInvoiceValue) => <p style={rowStyle}>{formatAmount(totalInvoiceValue)}</p>
    },
    {
        title: <div style={{ display: "flex", justifyContent: "center" }}>Action</div>,
        width: 80,
        align: "center",
        dataIndex: "action",
        key: "action",
        render: (_, detail, __, onActionDownload) => (
            <div
                style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", cursor: "pointer" }}
                onClick={() => onActionDownload?.(detail)}
                role="button"
                tabIndex={0}
                onKeyDown={(event) => {
                    if (event?.key === "Enter" || event?.key === " ") {
                        onActionDownload?.(detail);
                    }
                }}
            >
                <CloudDownloadOutlined aria-label="Download" />
            </div>
        )
    }
];

export const getGstInvoiceColumns = ({ onActionDownload, activeTabKey, isRefundTab } = {}) => {
    const isRefund = Boolean(isRefundTab) || String(activeTabKey) === "3";

    return GST_INVOICE_COLUMNS
        ?.filter((column) => (isRefund ? column?.key !== "gstAmount" : true))
        ?.map((column) => {
            if (column?.key !== "action") {
                return column;
            }

            return {
                ...column,
                render: (_, detail, index) => column?.render?.(_, detail, index, onActionDownload)
            };
        });
};

export const TDS_COLUMNS = [
    {
        title: "SNO",
        width: 70,
        align: "center",
        render: (_, __, index) => <>{index + 1}</>
    },
    {
        title: "Advocate ID",
        width: 140,
        dataIndex: "lawyerNo",
        key: "lawyerNo",
        render: (text) => <p style={rowStyle}>{text || "Nil"}</p>
    },
    {
        title: "Advocate Name",
        width: 160,
        dataIndex: "name",
        key: "name",
        render: (text) => <p style={{ fontWeight: "bold", ...rowStyle }}>{text || "Nil"}</p>
    },
    {
        title: "PAN Num",
        width: 140,
        dataIndex: "panNum",
        key: "panNum",
        render: (text) => <p style={rowStyle}>{text || "Nil"}</p>
    },
    {
        title: "Mobile NO",
        width: 150,
        dataIndex: "mobileNumber",
        key: "mobileNumber",
        render: (text) => <p style={rowStyle}>{formatPhoneNumber(text) || "Nil"}</p>
    },
    {
        title: "Email ID",
        width: 180,
        dataIndex: "email",
        key: "email",
        render: (text) => <p style={rowStyle}>{text || "Nil"}</p>
    },
    {
        title: "Earned amount above TDS",
        width: 190,
        dataIndex: "earnedAmountAboveTds",
        key: "earnedAmountAboveTds",
        render: (value) => <p style={rowStyle}>{`₹ ${formatAmount(value)}`}</p>
    },
    {
        title: "TDS Amount",
        width: 140,
        dataIndex: "tdsAmount",
        key: "tdsAmount",
        render: (value) => <p style={rowStyle}>{`₹ ${formatAmount(value)}`}</p>
    }
];

